import styled from '@emotion/styled'
import { ReactNode } from 'react'

import { Avatar, AvatarProps } from './Avatar'
import { HoverCard } from './HoverCard'
import { Color, theme } from '../constants'
import { StyleProps } from '../utils'

const AVATAR_OVERLAP_PX = 8

const Stack = styled.div({
  borderRadius: theme.border.radius.normal,
  display: 'flex',
  paddingLeft: AVATAR_OVERLAP_PX,
  transition: `filter ${theme.animation.transition}`,
})

const StyledAvatar = styled(Avatar)({
  border: `2px solid ${Color.WHITE}`,
  boxSizing: 'content-box',
  marginLeft: -AVATAR_OVERLAP_PX,
})

export type AvatarStackProps = {
  avatars: AvatarProps[]
  className?: string
  hoverCardContent?: ReactNode
  styles?: StyleProps
}

export const AvatarStack = (props: AvatarStackProps) => {
  const avatarStack = (
    <Stack className={props.className}>
      {props.avatars.map((avatar, index) => (
        <StyledAvatar key={index} {...avatar} />
      ))}
    </Stack>
  )

  return props.hoverCardContent ? (
    <HoverCard trigger={avatarStack}>{props.hoverCardContent}</HoverCard>
  ) : (
    avatarStack
  )
}
